import _get from 'lodash/get'
import Mola from '../api/mola'
import types from '../constants'

export const getReminders = (order) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  dispatch({
    type: types.GET_REMINDERS_LOADING,
    payload: {
      meta: {
        status: 'LOADING',
        error: ''
      }
    }
  })
  return Mola.getReminders(token, order).then((response) => {
    if (response.meta.status === 'error') {
      dispatch({
        type: types.GET_REMINDERS_ERROR,
        payload: {
          meta: {
            status: 'ERROR',
            error: ''
          }
        }
      })
    } else {
      dispatch({
        type: types.GET_REMINDERS_SUCCESS,
        payload: {
          meta: {
            status: 'SUCCESS',
            error: ''
          },
          data: response.data
        }
      })
    }
  })
}

export const addReminder = (id) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  return Mola.postReminder(token, id).then((response) => {
    return response
  })
    .catch(err => {
      return 'ERROR'
    })
}

export const deleteReminder = (id) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  return Mola.deleteReminder(token, id).then((response) => {
    return response
  })
    .catch(err => {
      return 'ERROR'
    })
}

export const getBatchReminder = (playlistId, ids, page, catalogId = null) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  let result = {
    playlistId: playlistId,
    reminders: {
      meta: {
        status: 'success',
        page: page,
      },
      data: []
    }
  }
  if (token) {
    result.reminders.meta.status = 'loading'
    if (page === 'home') {
      dispatch({
        type: types.HOME_VIDEO_REMINDERS_LOADING,
        payload: result
      })
    } else if (page === 'feature') {
      dispatch({
        type: types.FEATURE_VIDEO_REMINDERS_LOADING,
        id: catalogId,
        payload: result
      })
    }
    return Mola.getBatchReminder(token, ids).then((response) => {
      if (response.meta.status === 'SUCCESS') {
        result.reminders.meta.status = 'success'
        result.reminders.data = response.data
        if (page === 'home') {
          dispatch({
            type: types.HOME_VIDEO_REMINDERS,
            payload: result
          })
        } else if (page === 'feature') {
          dispatch({
            type: types.FEATURE_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'playlist') {
          dispatch({
            type: types.PLAYLIST_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'recommendation') {
          dispatch({
            type: types.RECOMMENDATION_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'matches') {
          dispatch({
            type: types.MATCHES_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'league-matches') {
          dispatch({
            type: types.MATCHES_PLAYLISTS_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        }
      } else {
        // if (response.errorStatus === 401) {
        //   console.log('unauthor')
        // } else {
        // console.log('selain 401')
        result.reminders.meta.status = 'error'
        if (page === 'home') {
          dispatch({
            type: types.HOME_VIDEO_REMINDERS,
            payload: result
          })
        } else if (page === 'feature') {
          dispatch({
            type: types.FEATURE_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'playlist') {
          dispatch({
            type: types.PLAYLIST_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'recommendation') {
          dispatch({
            type: types.RECOMMENDATION_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'matches') {
          dispatch({
            type: types.MATCHES_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        } else if (page === 'league-matches') {
          dispatch({
            type: types.MATCHES_PLAYLISTS_VIDEO_REMINDERS,
            id: catalogId,
            payload: result
          })
        }
        //}
      }
    })
      .catch(err => {
        // console.log(err, 'error')
      })
  } else {
    result.reminders.status = 'unauthorized'
    if (page === 'home') {
      dispatch({
        type: types.HOME_VIDEO_REMINDERS,
        payload: result
      })
    } else if (page === 'feature') {
      dispatch({
        type: types.FEATURE_VIDEO_REMINDERS,
        id: catalogId,
        payload: result
      })
    } else if (page === 'playlist') {
      dispatch({
        type: types.PLAYLIST_VIDEO_REMINDERS,
        id: catalogId,
        payload: result
      })
    } else if (page === 'recommendation') {
      dispatch({
        type: types.RECOMMENDATION_VIDEO_REMINDERS,
        id: catalogId,
        payload: result
      })
    } else if (page === 'matches') {
      dispatch({
        type: types.MATCHES_VIDEO_REMINDERS,
        id: catalogId,
        payload: result
      })
    } else if (page === 'league-matches') {
      dispatch({
        type: types.MATCHES_PLAYLISTS_VIDEO_REMINDERS,
        id: catalogId,
        payload: result
      })
    }
  }
}

export const getReminder = (id, page) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  let result = {
    reminder: {
      meta: {
        status: 'success'
      },
      data: {
        status: 0
      }
    }
  }
  if (token) {
    dispatch({
      type: types.MOVIE_DETAIL_REMINDER_LOADING,
      payload: {
        reminder: {
          meta: {
            status: 'loading'
          },
          data: null
        }
      }
    })
    return Mola.getReminder(token, id).then((response) => {
      if (response.meta.status === 'SUCCESS') {
        let reminderData = {
          status: _get(response, 'data.attributes.status', 0)
        }
        result.reminder.data = { ...reminderData }
        if (page === 'movie-detail') {
          dispatch({
            type: types.MOVIE_DETAIL_REMINDER,
            payload: result
          })
        }
      } else {
        result.reminder.meta.status = 'error'
        result.reminder.data = null
        if (page === 'movie-detail') {
          dispatch({
            type: types.MOVIE_DETAIL_REMINDER,
            payload: result
          })
        }
      }
    })
  } else {
    result.reminder.meta.status = 'unauthorized'
    if (page === 'movie-detail') {
      dispatch({
        type: types.MOVIE_DETAIL_REMINDER,
        payload: result
      })
    }
  }
}

export const getFavorite = (order) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  dispatch({
    type: types.GET_FAVORITE_LOADING,
    payload: {
      meta: {
        status: 'LOADING',
        error: ''
      }
    }
  })
  return Mola.getFavorite(order, token).then((response) => {
    if (response.meta.status === 'error') {
      dispatch({
        type: types.GET_FAVORITE_ERROR,
        payload: {
          meta: {
            status: 'ERROR',
            error: '',
            statusError: ''
          }
        }
      })
    } else {
      dispatch({
        type: types.GET_FAVORITE_SUCCESS,
        payload: {
          meta: {
            status: 'SUCCESS',
            error: ''
          },
          data: response.data
        }
      })
    }
  })
}

export const addFavorite = (id, type) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  return Mola.addFavorite(id, type, token).then((response) => {
    return response
  })
}

export const deleteFavorite = (id, type) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  return Mola.deleteFavorite(id, type, token).then((response) => {
    return response
  })
}

export const checkFavorite = (id, type) => (dispatch, getState) => {
  const token = _get(getState(), 'user.token', '')
  return Mola.checkFavorite(id, type, token).then((response) => {
    return response
  })
}

